import {createApp} from "vue";
import axios from 'axios';

import "bootstrap/dist/js/bootstrap.js"
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// Design system — loaded AFTER Bootstrap so our tokens/utilities win.
import './assets/design-system.css';
import {initTheme} from './utils/theme';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue3Toastify from 'vue3-toastify';
import {Amplify} from 'aws-amplify';
import {getCurrentUser} from 'aws-amplify/auth';
import {sessionStorage} from 'aws-amplify/utils';
import {cognitoUserPoolsTokenProvider} from 'aws-amplify/auth/cognito'
import {config} from './runtimeConfig';
import {resolveAuthReady} from './utils/authReady';

initTheme();

const app = createApp(App);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.backendBaseUrl;  // the FastAPI backend

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: config.cognitoUserPoolClientId,
            userPoolId: config.cognitoUserPoolId,
        }
    }
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

async function isAuthenticated_background_at_main_load() {
    try {
        const user = await getCurrentUser();
        console.log('at page load a user was found');
        // eslint-disable-next-line
        await store.dispatch('auth/fetchSession', user);
    } catch (error) {
        //  console.error(error);
        await store.dispatch('auth/fetchSession', null);
    }
}

// Fire-and-forget so public pages render immediately (app.mount below is not
// blocked on auth). When the initial restore settles, flip the auth-ready signal
// so guards and views that depend on auth can react.
isAuthenticated_background_at_main_load().finally(() => {
    store.commit('auth/SET_INITIALIZED', true);
    resolveAuthReady();
});

app.use(router);
app.use(store);
app.use(Vue3Toastify, {
    autoClose: 3000,
});

app.mount("#app");